import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import "react-datepicker/dist/react-datepicker.css";
// import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useSWR from "swr";
import VacancyTemplate from "./VacancyTemplate";
import SearchBar from "./SearchBar";
import LoadingAnimation from "../loadingAnimation/loadingAnimation";
// import { generateLocationString } from "../util/text";

// import SearchBar from "./components/common/SearchBar";

export default function CreateBookingForm() {
  const addComma = str => (str !== "" ? `${str}, ` : "");

  const generateLocationString = (address, town, county, postcode) => {
    const output = `${addComma(address)}${addComma(town)}${addComma(
      county
    )}${addComma(postcode)}`;
    return output.substring(0, output.length - 2); // removes final ,\s
  };

  const { data: bookings, error } = useSWR(`/vacancies`);

  const [showModal, setShowModal] = useState(false);
  const vacancies = bookings; // bookings;
  const [filtered, setFiltered] = useState(bookings); // useState(bookings);
  const [search, setSearch] = useState(null);

  useEffect(() => {
    setFiltered(bookings);
  }, [bookings]);

  useEffect(() => {
    if (search) {
      const filter = vacancies.filter(vacancy =>
        vacancy.title.toLowerCase().includes(search.toLocaleLowerCase())
      );
      setFiltered(filter);
    }
  }, [search]);

  if (!bookings) {
    return <LoadingAnimation />;
  }

  const reset = () => {
    setFiltered(vacancies);
    setSearch("");
  };

  const data = () =>
    filtered.map(vacancy => {
      const {
        vacancyID,
        title,
        clientID,
        address,
        town,
        county,
        postcode,
        creatorEmail,
        createdAt,
        payRate,
        description
      } = vacancy;
      const location = generateLocationString(address, town, county, postcode);

      const date = DateTime.fromISO(createdAt).toLocaleString(
        DateTime.DATETIME_SHORT
      );
      return (
        <VacancyTemplate
          key={vacancyID}
          vacancyID={vacancyID}
          title={title}
          clientID={clientID}
          location={location}
          createdAt={date}
          createdBy={creatorEmail}
          payrate={payRate}
          description={description}
        />
      );
    });

  const Modal = () => (
    <div>
      {showModal ? (
        <div>
          <div className="tw-flex tw-justify-center tw-items-center tw-overflow-x-hidden tw-fixed tw-inset-0 tw-z-20">
            <div className="lg:tw-w-1/2 sm:tw-w-3/4 tw-w-4/5">
              <div className="tw-border-0 tw-rounded-lg tw-flex tw-flex-col tw-w-full tw-bg-white">
                <div className=" tw-flex tw-items-start tw-justify-between tw-p-5 tw-shadow-md">
                  <h3 className="tw-text-3xl tw-font-semibold">
                    Vacancy Templates
                  </h3>
                  <div
                    className="tw-flex tw-justify-end tw-pr-1"
                    onClick={() => setShowModal(false)}
                  >
                    <div className="hover:tw-text-red-500 tw-cursor-pointer">
                      <svg
                        className="tw-h-8 tw-w-8"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="tw-flex tw-px-6 tw-py-2 tw-flex-col">
                  <div className="tw-w-full tw-flex  tw-items-center">
                    <SearchBar
                      defaultValue={search}
                      cancel={() => reset()}
                      onEnter={inputValue => setSearch(inputValue)}
                      style="md:tw-w-3/4 tw-w-4/5"
                    />
                    <h3 className="md:tw-mx-0 sm:tw-text-xl tw-text-sm">
                      {filtered.length} Templates
                    </h3>
                  </div>
                </div>
                <div
                  style={{ maxHeight: 280 }}
                  className="tw-flex  tw-overflow-y-auto  tw-justify-start tw-w-full  tw-px-6  tw-flex-col "
                >
                  {!error ? data() : <h3>Error loading vacancy templates.</h3>}
                </div>
                <div className="tw-pb-3"></div>
              </div>
            </div>
          </div>
          <div className="tw-opacity-50 tw-inset-0 tw-z-10 tw-bg-gray-700 tw-fixed"></div>
        </div>
      ) : null}
    </div>
  );

  const Option = ({ title, img, alt, href }) => {
    const optionDiv = (
      <div
        className="tw-w-full tw-h-3/4 tw-flex tw-justify-center tw-items-center"
        style={{ padding: 15 }}
      >
        <div
          onClick={() => (!href ? setShowModal(!showModal) : {})}
          className="hover:tw-bg-gray-100 tw-cursor-pointer tw-shadow-xl tw-border-2 tw-border-2  tw-bg-white tw-rounded-2xl tw-w-3/4 tw-h-3/4 tw-flex-col tw-font-bold tw-justify-center tw-items-center"
          style={{ padding: 35 }}
        >
          <h1 className="tw-text-center lg:tw-text-3xl md:tw-text-2xl tw-text-xl tw-pb-5">
            {" "}
            {title}{" "}
          </h1>
          <div className="tw-flex tw-justify-center">
            <img className="tw-h-1/2 tw-w-1/2" src={img} alt={alt} />
          </div>
        </div>
      </div>
    );

    if (!href) return optionDiv; // open modal instead for template link

    return (
      <Link
        to={href}
        style={{ textDecoration: "none", padding: 15, color: "black" }}
        className="tw-w-full tw-h-3/4 tw-flex tw-justify-center tw-items-center"
      >
        <div
          className="hover:tw-bg-gray-100 tw-cursor-pointer tw-shadow-xl tw-border-2 tw-border-2  tw-bg-white tw-rounded-2xl tw-w-3/4 tw-h-3/4 tw-flex-col tw-font-bold tw-justify-center tw-items-center"
          style={{ padding: 35 }}
        >
          <h1 className="tw-text-center lg:tw-text-3xl md:tw-text-2xl tw-text-xl tw-pb-5">
            {" "}
            {title}{" "}
          </h1>
          <div className="tw-flex tw-justify-center">
            <img className="tw-h-1/2 tw-w-1/2" src={img} alt={alt} />
          </div>
        </div>
      </Link>
    );
  };

  document.body.style.overflowY = showModal ? "hidden" : ""; // need this for the modal when open

  return (
    <div>
      {<Modal />}
      <div className="lg:tw-px-20 tw-px-0 tw-py-10">
        <div className="tw-py-2 tw-px-14 tw-flex tw-flex-col">
          <div className="md:tw-flex-row tw-flex-col tw-flex">
            <Option
              title="Create New"
              img="/images/dashboard/blank_doc_2.svg"
              alt="blank document icon"
              href="/vacancies/create"
            />
            <Option
              title="Use Template"
              img="/images/dashboard/template_doc_2.svg"
              alt="template document icon"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
